"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Is = exports.isClient = exports.isInteger = exports.isServer = exports.isWechat = exports.isMiniProgram = exports.isValidDate = exports.isBankCard = exports.isIDCard = exports.isMobile = exports.isEmail = exports.isUrl = exports.isMap = exports.isElement = exports.isWindow = exports.isPromise = exports.isEmpty = exports.isArray = exports.isRegExp = exports.isBoolean = exports.isFunction = exports.isString = exports.isNumber = exports.isNumeric = exports.isNullOrUnDef = exports.isNullAndUnDef = exports.isNull = exports.isDate = exports.isObject = exports.isUnDef = exports.isDef = exports.is = void 0;
const { toString } = Object.prototype;
function is(val, type) {
    return toString.call(val) === `[object ${type}]`;
}
exports.is = is;
function isDef(val) {
    return typeof val !== 'undefined';
}
exports.isDef = isDef;
function isUnDef(val) {
    return !isDef(val);
}
exports.isUnDef = isUnDef;
function isObject(val) {
    return val !== null && is(val, 'Object');
}
exports.isObject = isObject;
function isDate(val) {
    return is(val, 'Date');
}
exports.isDate = isDate;
function isNull(val) {
    return val === null;
}
exports.isNull = isNull;
function isNullAndUnDef(val) {
    return isUnDef(val) && isNull(val);
}
exports.isNullAndUnDef = isNullAndUnDef;
function isNullOrUnDef(val) {
    return isUnDef(val) || isNull(val);
}
exports.isNullOrUnDef = isNullOrUnDef;
function isNumeric(val) {
    return /^[+-]?\d+(\.\d+)?([Ee][+-]?\d+)?$/g.test(String(val));
}
exports.isNumeric = isNumeric;
function isNumber(val) {
    return is(val, 'Number');
}
exports.isNumber = isNumber;
function isString(val) {
    return is(val, 'String');
}
exports.isString = isString;
function isFunction(val) {
    return typeof val === 'function';
}
exports.isFunction = isFunction;
function isBoolean(val) {
    return is(val, 'Boolean');
}
exports.isBoolean = isBoolean;
function isRegExp(val) {
    return is(val, 'RegExp');
}
exports.isRegExp = isRegExp;
function isArray(val) {
    return val && Array.isArray(val);
}
exports.isArray = isArray;
function isEmpty(val) {
    if (isArray(val) || isString(val)) {
        return val.length === 0;
    }
    if (val instanceof Map || val instanceof Set) {
        return val.size === 0;
    }
    if (isObject(val)) {
        return Object.keys(val).length === 0;
    }
    return false;
}
exports.isEmpty = isEmpty;
function isPromise(val) {
    return (is(val, 'Promise') &&
        isObject(val) &&
        isFunction(val.then) &&
        isFunction(val.catch));
}
exports.isPromise = isPromise;
function isWindow(val) {
    return typeof window !== 'undefined' && is(val, 'Window');
}
exports.isWindow = isWindow;
function isElement(val) {
    return isObject(val) && !!val.tagName;
}
exports.isElement = isElement;
function isMap(val) {
    return is(val, 'Map');
}
exports.isMap = isMap;
function isUrl(val) {
    return new RegExp('^' +
        // protocol identifier (optional)
        // short syntax // still required
        '(?:(?:(?:https?|ftp):)?\\/\\/)' +
        // user:pass BasicAuth (optional)
        '(?:\\S+(?::\\S*)?@)?' +
        '(?:' +
        // IP address exclusion
        // private & local networks
        '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
        '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
        '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
        // IP address dotted notation octets
        // excludes loopback network 0.0.0.0
        // excludes reserved space >= 224.0.0.0
        // excludes network & broadcast addresses
        // (first & last IP address of each class)
        '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
        '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
        '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
        '|' +
        // host & domain names, may end with dot
        // can be replaced by a shortest alternative
        // (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
        '(?:' +
        '(?:' +
        '[a-z0-9\\u00a1-\\uffff]' +
        '[a-z0-9\\u00a1-\\uffff_-]{0,62}' +
        ')?' +
        '[a-z0-9\\u00a1-\\uffff]\\.' +
        ')+' +
        // TLD identifier name, may end with dot
        '(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' +
        ')' +
        // port number (optional)
        '(?::\\d{2,5})?' +
        // resource path (optional)
        '(?:[/?#]\\S*)?' +
        '$', 'i').test(val);
}
exports.isUrl = isUrl;
function isEmail(val) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val);
}
exports.isEmail = isEmail;
function isMobile(val) {
    const reg = /^1[3-9]\d{9}$/;
    return reg.test(val);
}
exports.isMobile = isMobile;
function isIDCard(val) {
    const reg = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
    return reg.test(val);
}
exports.isIDCard = isIDCard;
function isBankCard(val) {
    const reg = /^([1-9])(\d{15}|\d{18})$/;
    return reg.test(val);
}
exports.isBankCard = isBankCard;
function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
}
exports.isValidDate = isValidDate;
// 是否在小程序中
exports.isMiniProgram = typeof window !== 'undefined' && /miniProgram/i.test(navigator.userAgent.toLowerCase());
// 是否在微信浏览器中
exports.isWechat = typeof window !== 'undefined' && /MicroMessenger/i.test(window.navigator.userAgent);
exports.isServer = typeof window === 'undefined';
const isInteger = (num) => {
    return typeof num === 'number' && num % 1 === 0;
};
exports.isInteger = isInteger;
exports.isClient = !exports.isServer;
exports.Is = {
    enabled: {
        cookies: () => navigator.cookieEnabled,
        notifications: () => 'Notification' in window && Notification.permission === 'granted',
        pushNotifications: () => 'PushManager' in window,
        geolocation: () => 'geolocation' in navigator,
        geoLocation: () => 'geolocation' in navigator,
        webWorkers: () => 'Worker' in window,
        serviceWorker: () => 'serviceWorker' in navigator,
        microphone: () => 'mediaDevices' in navigator && 'getUserMedia' in navigator,
        camera: () => 'mediaDevices' in navigator && 'getUserMedia' in navigator,
        cam: () => 'mediaDevices' in navigator && 'getUserMedia' in navigator,
        webcam: () => 'mediaDevices' in navigator && 'getUserMedia' in navigator,
        webRTC: () => 'RTCPeerConnection' in window,
        webAudio: () => 'AudioContext' in window,
        speechRecognition: () => 'webkitSpeechRecognition' in window,
        speechSynthesis: () => 'speechSynthesis' in window,
        localStorage: () => 'localStorage' in window,
        sessionStorage: () => 'sessionStorage' in window,
        indexedDB: () => 'indexedDB' in window,
        fetch: () => 'fetch' in window,
        history: () => 'history' in window,
        fullScreen: () => 'fullscreenEnabled' in document,
        fullscreen: () => 'fullscreenEnabled' in document,
        vibration: () => 'vibrate' in navigator,
        touch: () => 'ontouchstart' in window,
        battery: () => 'getBattery' in navigator,
        darkMode: () => window.matchMedia('(prefers-color-scheme: dark)').matches,
        lightMode: () => window.matchMedia('(prefers-color-scheme: light)').matches,
        animation: () => 'AnimationEvent' in window,
        transition: () => 'TransitionEvent' in window,
    },
    mobile: {
        android: () => navigator.userAgent.match(/Android/i) !== null,
        ios: () => navigator.userAgent.match(/iPhone|iPad|iPod/i) !== null,
        iphone: () => navigator.userAgent.match(/iPhone/i) !== null,
        ipad: () => navigator.userAgent.match(/iPad/i) !== null,
        ipod: () => navigator.userAgent.match(/iPod/i) !== null,
        windows: () => navigator.userAgent.match(/IEMobile/i) !== null,
        wechat: () => navigator.userAgent.match(/MicroMessenger/) !== null,
        any: () => exports.Is.mobile.android() || exports.Is.mobile.ios() || exports.Is.mobile.windows(),
    },
    desktop: () => !exports.Is.mobile.any(),
    browser(browser) {
        // Opera 8.0+
        const isOpera = (!!window.opr && !!opr.addons) ||
            !!window.opera ||
            navigator.userAgent.indexOf(' OPR/') >= 0;
        // Firefox 1.0+
        const isFirefox = typeof window.InstallTrigger !== 'undefined';
        // Safari 3.0+ "[object HTMLElementConstructor]"
        const isSafari = /constructor/i.test(window.HTMLElement) ||
            ((p) => {
                return p.toString() === '[object SafariRemoteNotification]';
            })(!window.safari ||
                (typeof safari !== 'undefined' && safari.pushNotification));
        // Internet Explorer 6-11
        const isIE = !!document.documentMode;
        // Edge 20+
        const isEdge = !isIE && !!window.StyleMedia;
        // Chrome 1 - 71
        const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
        const browsersList = {
            chrome: isChrome,
            firefox: isFirefox,
            opera: isOpera,
            edge: isEdge,
            ie: isIE,
            safari: isSafari,
        };
        return browsersList[browser.toLowerCase()] === true;
    },
    chrome: () => !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime),
    firefox: () => typeof window.InstallTrigger !== 'undefined',
    safari: () => {
        const isSafari = /constructor/i.test(window.HTMLElement) ||
            ((p) => {
                return p.toString() === '[object SafariRemoteNotification]';
            })(!window.safari ||
                (typeof safari !== 'undefined' && safari.pushNotification));
        return isSafari;
    },
    opera: () => {
        const isOpera = (!!window.opr && !!opr.addons) ||
            !!window.opera ||
            navigator.userAgent.indexOf(' OPR/') >= 0;
        return isOpera;
    },
    ie: () => !!document.documentMode,
    edge: () => {
        // Internet Explorer 6-11
        const isIE = !!document.documentMode;
        const isEdge = !isIE && !!window.StyleMedia;
        return isEdge;
    },
};
//# sourceMappingURL=is.js.map